/**
 * @generated SignedSource<<fccc284335f52055c47466b2d83dd099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLOnboardingTaskId = "CHAT_WITH_TIERZERO" | "CONNECT_CODE" | "CONNECT_DOCUMENTATION" | "CONNECT_MESSAGING" | "CONNECT_ONCALL" | "CONNECT_TELEMETRY" | "CREATE_AND_RUN_FIRST_DIGEST" | "CREATE_FIRST_ALERT_RESPONDER" | "INSPECT_INTEGRATION_RESOURCES" | "INTEGRATION_SETUP" | "KNOWLEDGE_SETUP" | "LEARN_ALERT_RESPONDER" | "LEARN_CHAT" | "LEARN_DIGEST" | "MANAGE_MEMORY" | "SETUP_INTEGRATIONS" | "SETUP_TEAM" | "TIERZERO_MD_SETUP" | "TIERZERO_USER_GUIDE" | "%future added value";
export type GraphQLOnboardingTaskStatusEnum = "COMPLETED" | "PENDING" | "TODO" | "TO_REVIEW" | "%future added value";
export type CreateOnboardingTaskStatusInput = {
  status: GraphQLOnboardingTaskStatusEnum;
  taskId: GraphQLOnboardingTaskId;
  teamId: any;
};
export type CreateOnboardingTaskStatusMutation$variables = {
  input: CreateOnboardingTaskStatusInput;
};
export type CreateOnboardingTaskStatusMutation$data = {
  readonly createOnboardingTaskStatus: {
    readonly taskStatus: {
      readonly completedAt: any | null | undefined;
      readonly completedByUser: {
        readonly firstName: string;
        readonly id: any;
        readonly lastName: string;
      } | null | undefined;
      readonly id: any;
      readonly status: GraphQLOnboardingTaskStatusEnum;
      readonly taskId: GraphQLOnboardingTaskId;
    };
  };
};
export type CreateOnboardingTaskStatusMutation = {
  response: CreateOnboardingTaskStatusMutation$data;
  variables: CreateOnboardingTaskStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOnboardingTaskStatusPayload",
    "kind": "LinkedField",
    "name": "createOnboardingTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLOnboardingTaskStatus",
        "kind": "LinkedField",
        "name": "taskStatus",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUser",
            "kind": "LinkedField",
            "name": "completedByUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOnboardingTaskStatusMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOnboardingTaskStatusMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "30eb6c73c8c107e9f8a3e77dd6dd2b34",
    "id": null,
    "metadata": {},
    "name": "CreateOnboardingTaskStatusMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOnboardingTaskStatusMutation(\n  $input: CreateOnboardingTaskStatusInput!\n) {\n  createOnboardingTaskStatus(input: $input) {\n    taskStatus {\n      id\n      taskId\n      status\n      completedAt\n      completedByUser {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3e3db50b34407658bca5e8f9fd6f641";

export default node;
